import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import auth from '@/store/okmenu/auth'
import businessTypes from '@/store/okmenu/business-types'
import branches from '@/store/okmenu/branches'
import setup from '@/store/okmenu/setup'
import permissions from '@/store/okmenu/permissions'
import subusers from '@/store/okmenu/subuser'
import ordering from '@/store/okmenu/ordering'
import subscription from '@/store/okmenu/subscription'
import pricing from '@/store/okmenu/pricing'
import purchase from '@/store/okmenu/purchase'
import vendor from '@/store/okmenu/vendor'
import menu from '@/store/okmenu/menu'
import modifiers from '@/store/okmenu/modifiers'
import stickers from '@/store/okmenu/stickers'
import reservation from '@/store/okmenu/reservation'
import queues from '@/store/okmenu/queues'
import design from '@/store/okmenu/design'
import qr from '@/store/okmenu/qr'
import devices from '@/store/okmenu/devices'
import widget from '@/store/okmenu/widget'
import domain from '@/store/okmenu/domain'
import orders from '@/store/okmenu/orders'
import coupons from '@/store/okmenu/coupons'
import discounts from '@/store/okmenu/discounts'
import newsletter from '@/store/okmenu/newsletter'
import navigation from '@/store/okmenu/navigation'
import help from '@/store/okmenu/help'
import quotation from '@/store/okmenu/quotation'
import superAdmin from '@/store/okmenu/super-admin'
import viral from '@/store/okmenu/viral'
import integrations from '@/store/okmenu/integrations'
import statistics from '@/store/okmenu/statistics'
import taxes from '@/store/okmenu/taxes'
import pos from '@/store/okmenu/pos'
import businessCategories from '@/store/okmenu/business-categories'
import campaign from '@/store/okmenu/campaign'
import inventory from '@/store/okmenu/inventory'
import orderDiscount from '@/store/okmenu/order-discount'
import returnOrders from '@/store/okmenu/return-orders'
import refunds from '@/store/okmenu/refunds'
import productReservations from '@/store/okmenu/product-reservations'
import business from '@/store/okmenu/restaurant'
import pickup from '@/store/okmenu/pickup'
import delivery from '@/store/okmenu/delivery'
import customerReviews from '@/store/okmenu/customer-reviews'
import b2b from '@/store/okmenu/b2b'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    newsletter,
    discounts,
    coupons,
    appConfig,
    verticalMenu,
    auth,
    businessTypes,
    branches,
    setup,
    permissions,
    subusers,
    ordering,
    subscription,
    pricing,
    purchase,
    vendor,
    menu,
    modifiers,
    stickers,
    qr,
    devices,
    widget,
    domain,
    design,
    queues,
    reservation,
    orders,
    navigation,
    help,
    quotation,
    superAdmin,
    viral,
    integrations,
    statistics,
    taxes,
    pos,
    businessCategories,
    inventory,
    campaign,
    returnOrders,
    refunds,
    productReservations,
    orderDiscount,
    business,
    pickup,
    delivery,
    customerReviews,
    b2b,
  },
  strict: process.env.DEV,
})
